import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
//import { Redirect } from 'react-router-dom';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';

const required = value => value ? undefined : 'Required'

const OutletSettingAddOrUpdate = ({ handleSubmit }) => {
    const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning } }) => (
        <div className="form__form-group">
            <div className="form__form-group">
                <input {...input} placeholder={placeholder} type={type} />
                {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
            </div>
        </div>
    )

    // const [isRedirect, setIsRedirect] = useState(false);

    // if (isRedirect) {
    //     return <Redirect to="/merchant/master/scheme/view" />;
    // }
    return (
        <form className="form-animated" onSubmit={handleSubmit}>
            <Col lg={12} md={12}>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">ETA Threshold (In Min)</span>
                            <div className="form__form-animated-group-field">
                                <Field name="riderId" component={renderField} type="text" placeholder="Registered Rider ID" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>

                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">Rider Pass Code</span>
                            <div className="form__form-group-field">
                                <Field name="riderId" component={renderField} type="text" placeholder="Rider Pass Code" validate={[required]} />

                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Uploading Time(HH:MM)</span>
                            <div className="form__form-group-field">
                                <Field name="licenceKey" component={renderField} type="text" placeholder="Enter the Hour" validate={[required]} />
                                <Field name="licenceKey" component={renderField} type="text" placeholder="Enter the Min" validate={[required]} />
                            </div>
                        </div>
                    </Col>

                </Row>
                <Row>
                    <Col md={6} lg={6}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Delivery Time (HH:MM)
                            </span>
                            <div className="form__form-animated-group-field">
                                <Field name="licenceKey" component={renderField} type="text" placeholder="Enter the Hour" validate={[required]} />
                                <Field name="licenceKey" component={renderField} type="text" placeholder="Enter the Min" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} lg={6}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Trip Close
                            </span>
                            <div className="form__form-group-field">
                                <Field
                                    name="tripStatus"
                                    component={renderToggleButtonField}
                                // defaultChecked
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <div className="form__form-group">
                                <span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Status</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="status"
                                        component={renderToggleButtonField}
                                        defaultChecked
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>

            <div className="form__OnboardingButton">
                <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                </ButtonToolbar>
            </div>

        </form>

    );
};


OutletSettingAddOrUpdate.propTypes = {
    OutletSettingAddOrUpdate: PropTypes.func.isRequired,
};


const mapStateToProps = (state, data) => {
    if (data && data.data) {
        return {
            initialValues: {
                // acquirer:data.tmsAcquirer.acquirerId,
                //tmsAcquirer: data.data?.tmsAcquirer?.acquirerId,
                //acquirerGuid:data.data.tmsAcquirer.acquirer_guid,
                // tmsAcquirer:{value:data.data.tmsAcquirer?.acquirer_guid,label:data?.data?.tmsAcquirer?.acquirerId},
                schemeId: data.data[0]?.schemeId,
                schemeName: data.data[0]?.schemeName,
                kernelId: data.data[0]?.kernelId,

            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'OutletSettingAddOrUpdateForm', enableReinitialize: true })(OutletSettingAddOrUpdate))